<script>
export default {
  name: "The_Footer"
}
</script>


<template>
  <footer class="w-full h-auto bg-sky-500">
    <section class="container mx-auto w-full h-auto justify-between items-center p-2">
      <p class="text-center text-white">
        © 2023 RayaGroup, LLC. All rights reserved.
      </p>
    </section>
  </footer>
</template>

<style scoped></style>
